import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import SpecimenCard from './SpecimenCard';
import type { SpecimenTaxonomy } from './taxonomyDatabase';

interface SpecimenTrayProps {
  specimens: SpecimenTaxonomy[];
  selectedId: string;
  hiddenIdentity?: boolean;
  onSelect: (specimenId: string) => void;
}

const SpecimenTray: React.FC<SpecimenTrayProps> = ({ specimens, selectedId, hiddenIdentity = false, onSelect }) => (
  <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1 }}>
    <Typography variant="subtitle1" fontWeight={800} sx={{ mb: 1 }}>Specimen tray</Typography>
    <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', pb: 1 }}>
      {specimens.map((specimen) => <Box key={specimen.id} sx={{ flex: '0 0 auto' }}><SpecimenCard specimen={specimen} selected={specimen.id === selectedId} hiddenIdentity={hiddenIdentity && specimen.id === selectedId} onSelect={onSelect} /></Box>)}
    </Box>
    <Stack direction="row" spacing={1} flexWrap="wrap"><Typography variant="caption" color="text.secondary">Cards show the five-kingdom label and domain mapping. Scientific names are italicized when identity is visible.</Typography></Stack>
  </Paper>
);

export default SpecimenTray;
